import React from "react";
import "../css/privacy.scss";

function Faqs() {
  return (
    <div className="privacy">
      <div className="policy-container">
        <h1>Frequently Asked Questions</h1>
        <h2>How can I contact isanroute?</h2>
        <p>Email send@isanroute.space and include your order number where relevant.</p>
        <h2>When will my order be dispatched?</h2>
        <p>In-stock orders are normally prepared within 1–2 business days. Tracking is sent by email after dispatch.</p>
        <h2>Can I change or cancel an order?</h2>
        <p>Contact us as soon as possible. We cannot guarantee changes after an order has entered fulfilment.</p>
        <h2>How do returns work?</h2>
        <p>Eligible unused items may be returned within 28 days of receipt. See our Returns page for conditions and the return address.</p>
        <h2>How should I choose a size?</h2>
        <p>Use the options shown on each product page. If you need additional measurements, email us before ordering.</p>
        <h2>What does shipping cost?</h2>
        <p>Shipping is a flat $9.99 USD per order and is included in the checkout total.</p>
        <h2>How is payment handled?</h2>
        <p>After you submit your delivery information, you are transferred to a secure hosted payment page. isanroute does not collect card numbers in its checkout form.</p>
        <h2>Which destinations are unavailable?</h2>
        <p>Countries restricted by applicable sanctions or carrier rules are removed from the country selector.</p>
      </div>
    </div>
  );
}

export default Faqs;
